import React from 'react'
import Droplet from '/img/svg/droplet'
import cx from 'classnames'

class Wayfinder extends React.Component {
  generateWayfinder() {
    const { routes, currentPage, theme } = this.props
    const currentRoute = currentPage.location.pathname
      ? currentPage.location.pathname
      : currentPage.pathname
    const pillarRoutes = routes.filter(route => route.type === 'pillar')
    const routeIndex = pillarRoutes.findIndex(route => {
      return route.url === currentRoute
    })
    const positionsArray = [
      'bottom-3 left-3',
      'top-3 left-3',
      'top-3 right-3',
      'bottom-3 right-3'
    ]
    const startingRotation = 225
    const rotationIncrement = 90

    return pillarRoutes.map((route, index) => (
      <div
        key={`wayfinder-${index}`}
        className={cx(
          `absolute origin-b text-jet-black rotate-${startingRotation +
            rotationIncrement * index} ${positionsArray[index]}`,
          {
            'fill-none': routeIndex != index
          }
        )}
      >
        <Droplet
          className={cx({
            'text-white': theme.bgColor === 'bg-danaher-blue'
          })}
        />
      </div>
    ))
  }

  render() {
    const { theme } = this.props

    return (
      <div
        className={`absolute top-0 w-90 md:w-200 h-90 md:h-200 -ml-45 md:-ml-100 -mt-90 md:-mt-135 left-half rotate-45 z-20 ${theme.bgColor}`}
      >
        <div className="absolute bottom-20 right-20 w-48 h-48">
          {this.generateWayfinder()}
        </div>
      </div>
    )
  }
}

export default Wayfinder
